@for (i of (priorityDensity ? [1, 2, 3, 4, 5, 6, 7] : [1]); track i; let index = $index) {
  <div
    class="priority-shape"
    #priorityShape
  [ngStyle]="{
    'clip-path': dataObject.shape,
    'transform': 'scale(' + (1 + index * 0.8) + ') ' + rotation,
    'opacity': index === 0 ? 0.5 : 0.35 - index * 0.04,
    'transform-origin': 'center',
  }"
  ></div>
}
